<header class="bg-primary text-white p-3 mb-4">
  <div class="container">
    <div class="d-flex justify-content-between align-items-center">
      <a
        [routerLink]="logoLink()"
        class="header-logo-link"
        [attr.aria-label]="logoAriaLabel()"
      >
        <img
          ngSrc="/EVr-Reg-Trade-White-Logo-768x240.webp"
          alt="EVready Energy Logo"
          width="200"
          height="62"
          priority
          class="img-fluid"
        />
      </a>
      @if (showAuthenticatedControls()) {
        <div class="d-flex flex-column align-items-end gap-2">
          <div class="d-flex align-items-center gap-3">
            <span class="text-light">Welcome, {{ displayName() }}</span>
            <button (click)="signOut()" class="btn btn-outline-light btn-sm">Sign Out</button>
          </div>
        </div>
      } @else if (showSignIn()) {
        <a routerLink="/login" class="btn btn-outline-light btn-sm">Sign In</a>
      }
    </div>
  </div>
</header>
